module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAO9JREFUOBHFU7ENwjAQvDcpKNkABkACAQWk8gYwAh07pGIMqJiBDUwDFCmyAemRUDooEhvbYClEllAACTfvO59P738/4blGIV8qiVNxwzZJRNYPeT8AppDYxUchnK4ayRCDMZ8zho07lAprRlgYbPaSsEr2InHn5cgM0Jc7ZZIUmg6bfSDRcrgarUGVrIP/b6AL/Vh5oSIGupKuhyR1UQUiEJ0bhG5OyJzu59G2cTjhMyL06rjn0P9Ft9Y+oSCkulV106yr9+dnn2C+MRS4TxIfhJf3aT/iyrPQfuvgGSxbRAkIJl/nwWemK5/6+K+4O7FmRtXyEr3CAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theory/ic_danhmucbaihoc.png
// module id = 1283
// module chunks = 0